import axios from "axios";

let setLoadingRef = null;

/**
 * This function is called once from App.js
 * to give axios access to global loading state
 */
export const setLoadingHandler = (setLoading) => {
  setLoadingRef = setLoading;
};

export const registerAxiosHandlers = (navigate, setPopupMsg) => {
  /* ===================== REQUEST ===================== */
  axios.interceptors.request.use(
    (config) => {
      if (setLoadingRef) {
        setLoadingRef(true); 
      }
      return config;
    },
    (error) => {
      if (setLoadingRef) {
        setLoadingRef(false);
      }
      return Promise.reject(error);
    }
  );

  /* ===================== RESPONSE ===================== */
  axios.interceptors.response.use(
    (response) => {
      if (setLoadingRef) {
        setLoadingRef(false); // 🔥 STOP LOADER
      }

      const code =
        response?.data?.Response_Code ||
        response?.data?.responseCode ||
        response?.data?.ResponseCode;

      // ✅ SESSION EXPIRED HANDLING (UNCHANGED)
      if (code === "99723") {
        setPopupMsg("Session expired. Please login again.");

        setTimeout(() => {
          sessionStorage.clear();
          localStorage.clear();
          navigate("/login");
        }, 1500);
      }

      return response;
    },
    (error) => {
      if (setLoadingRef) {
        setLoadingRef(false); 
      }

      console.error("API Error:", error);

      return Promise.reject(error);
    }
  );
};
